<template>
    <div>
        <div id="map"></div>
        <div v-if="is_cdn && showBanner" class="alert alert-warning fixed-bottom py-2 px-3 text-center map-banner shadow" role="alert">
            النظام يعمل ببيئة اقتصادية، وقد يظهر بطء في استرجاع البيانات.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="dismissBanner">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
    import maplibregl from 'maplibre-gl';
    import { Protocol } from "pmtiles";
    import 'maplibre-gl/dist/maplibre-gl.css';
    import './extend/MaplibreCustomControls.css'
    import {LoadingIndicatorTilesControl} from './extend/MaplibreCustomControls.js'
    import { ReachabilityControl, OptimizedRoutingControl ,SpeedConfigurationControl,TravelTimeMatrixControl } from './extend/GeocoderControls.js';
    export default {
        name: 'MapLibre',
        data() {
            return {
                showBanner: true
            }
        },
        props: {
            host: {
                type: String,
                default: ''
            },
            is_cdn: {
                type: Boolean,
                default: false
            }
        },
        components:{},
        methods:{
            dismissBanner() {
                this.showBanner = false;
                localStorage.setItem("mapBannerDismissed", "1");
            }
        },
        mounted() {
            //slow loading banner seen flag
            const dismissed = localStorage.getItem("mapBannerDismissed");
            if (dismissed === "1") this.showBanner = false;
            //auto dismiss for banner
            setTimeout(() => {this.dismissBanner();}, 7000);

            let style_url = this.host+'/map-styles/basic-v2.natrual_earth.style.json';
            // let style_url = this.host+'/map-styles/basic-v2.natrual_earth.style.json';
            // let style_url = 'https://maps.moh1024.com/map-styles/basic-v2.natrual_earth.style.json';
            if(this.is_cdn){
                style_url = this.host+'/map-styles/basic-v2.natrual_earth.style.cdn.pmtiles.json';
            }
            console.log("my host is ",)
            maplibregl.setRTLTextPlugin('/map-styles/js/mabbox-gl-rtl-text.0.2.3.js');
            
            let protocol = new Protocol();
            maplibregl.addProtocol("pmtiles",protocol.tile);
            
            const map = new maplibregl.Map({
                container: 'map', 
                center: [46.507305473960855,24.653632816223578], 
                zoom: 7, 
                updateWhileAnimating: true, 
                preload: Infinity,
                // style: 'https://maps.moh1024.com/map-styles/basic-v2.natrual_earth.style.json', 
                // style: this.host+'/map-styles/basic-v2.natrual_earth.style.json', 
                // style: this.host+'/map-styles/basic-v2.natrual_earth.style.cdn.pmtiles.json', 
                style: style_url, 
            });
            // document.querySelectorAll('.maplibregl-ctrl-attrib').forEach(element => element.remove());
            // setTimeout(()=>{document.querySelectorAll('.maplibregl-ctrl-attrib').forEach(element => element.remove());},100)

            setTimeout(()=>{document.querySelectorAll('.maplibregl-ctrl-attrib-button').forEach(element => element.click());},100)//this is to show the Attribution for legal reasons.

            map.addControl(new maplibregl.NavigationControl(),'top-right');
            map.addControl(new maplibregl.GeolocateControl({positionOptions: {enableHighAccuracy: true},trackUserLocation: true,showAccuracyCircle: false}),'top-right');
            
            
            if(!this.is_cdn){
                map.addControl(new SpeedConfigurationControl(), 'top-left');
                map.addControl(new ReachabilityControl(), 'top-left');
                map.addControl(new OptimizedRoutingControl(), 'top-left');
                map.addControl(new TravelTimeMatrixControl(), 'top-left');
            }else{
                map.addControl(new LoadingIndicatorTilesControl(),'bottom-left');
            }
        }
    }
</script>

<style scoped>
    #map {
        width: 100%;
        height: 100%;
        /* width: 200%;
        height: 200%;
        left: -50%;
        top: -50%; */
        position: absolute;
        background: #b3b3b3;
    }
    .map-banner {
        left: 0;
        right: 0;
        width: 50%;
        margin: auto;
        bottom: 5px;
    }
    
</style>
